<app-iboxx-screener-page [indexType]="'futures'"></app-iboxx-screener-page>
